(function(){
  'use strict';
  if (window.matchMedia && !window.matchMedia('(max-width:749px)').matches) return;

  var C = window.SoulStoneMobileApp || {};
  var q = function(s,r){ return (r || document).querySelector(s); };
  var qa = function(s,r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function(v){ return String(v || '').replace(/[&<>"']/g,function(m){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]; }); };
  var pathOf = function(url){ try{return new URL(url,location.origin).pathname.toLowerCase().replace(/\/$/,'') || '/';}catch(e){return '';} };

  function addTabs(main,path,isProduct){
    if (!main || isProduct || q('.ssm-section-tabs',main)) return;
    if (!(path.indexOf('/collections/') === 0 || path.indexOf('/pages/') === 0)) return;

    var links = [
      [C.shop || '/pages/shop-all','Shop'],
      [C.crystals || '/collections/crystals','Crystals'],
      [C.apparel || '/collections/clothing-and-merch','Apparel & Merch'],
      [C.decks || '/pages/decks','Decks'],
      [C.designs || '/pages/uv-dtf-dtf','Designs'],
      [C.soulNotes || '/pages/soul-notes','Soul Notes']
    ];
    var nav = document.createElement('nav');
    nav.className = 'ssm-section-tabs';
    nav.setAttribute('aria-label','SoulStone sections');
    nav.innerHTML = links.map(function(item){
      var p = pathOf(item[0]);
      var current = p && (path === p || (p.indexOf('/collections/') === 0 && path === p));
      return '<a href="' + esc(item[0]) + '"' + (current ? ' class="is-current" aria-current="page"' : '') + '>' + esc(item[1]) + '</a>';
    }).join('');
    main.insertBefore(nav,main.firstChild);
    var active = q('.is-current',nav);
    if (active) setTimeout(function(){ try{active.scrollIntoView({inline:'center',block:'nearest'});}catch(e){} },40);
  }

  function classify(main,path){
    if (!main || /^\/pages\/soul-notes-(?:intuition-messages|healing-shadow-work|manifestation-mindset)$/.test(path) || path === '/pages/decks' || path === '/pages/readings' || path === '/collections/readings' || path === '/pages/crystals' || /^\/collections\/(?:crystals|protection-crystals|clarity-crystals|abundance-crystals|grounding-crystals|love-healing-crystals|energy-cleanse-crystals|spiritual-growth-crystals)$/.test(path)) return;
    var isCollection = path.indexOf('/collections/') === 0;
    var isProduct = path.indexOf('/products/') === 0;
    var isPage = path.indexOf('/pages/') === 0;

    document.body.classList.add('ssm-inner');
    if (isCollection) document.body.classList.add('ssm-catalog');
    if (isProduct) document.body.classList.add('ssm-product-page');
    if (isPage) document.body.classList.add('ssm-page');
    if (/soul-notes/.test(path)) document.body.classList.add('ssm-soulnotes');
    if (/deck|tarot|oracle/.test(path)) document.body.classList.add('ssm-decks');
    if (/apparel|clothing|merch/.test(path)) document.body.classList.add('ssm-apparel');
    if (/uv-dtf|dtf|design/.test(path)) document.body.classList.add('ssm-designs');
    if (/reading/.test(path)) document.body.classList.add('ssm-readings');

    addTabs(main,path,isProduct);

    var title = q('h1',main);
    if (title) title.classList.add('ssm-screen-title');

    qa(':scope > .shopify-section',main).forEach(function(section,index){
      var hasMediaHero = !!q('.slideshow,.banner,.image-banner,[class*="image-banner"]',section);
      var hasCatalog = !!q('.product-grid,.collection,.facets-container,[id*="ProductGridContainer"]',section);
      var hasProductDetail = !!q('.product__info-wrapper,.product__media-wrapper,product-info',section);
      var cardCount = qa('product-card,.product-card,.card-wrapper,.card-product',section).length;

      if (hasMediaHero) section.classList.add('ssm-inner-media');
      else if (!hasCatalog && !hasProductDetail) section.classList.add('ssm-inner-surface');

      if (cardCount >= 2 && !hasCatalog) section.classList.add('ssm-inner-shelf');
      if (index === 0) section.classList.add('ssm-inner-first');
    });

    if (isCollection) {
      qa('.product-grid,ul.product-grid,[data-product-grid]',main).forEach(function(grid){
        grid.classList.remove('ssm-horizontal-products');
        grid.classList.add('ssm-catalog-grid');
        var section = grid.closest('.shopify-section');
        if (section) {
          section.classList.remove('ssm-product-section','ssm-has-rail','ssm-inner-surface');
          section.classList.add('ssm-catalog-section');
        }
      });
    }

    if (isProduct) {
      qa('.ssm-horizontal-products',main).forEach(function(grid){ grid.classList.remove('ssm-horizontal-products'); });
      var first = q(':scope > .shopify-section',main);
      if (first) first.classList.remove('ssm-inner-surface','ssm-inner-media','ssm-product-section','ssm-has-rail');
    }

    qa('a.button,button.button,.button',main).forEach(function(el){ el.classList.add('ssm-pressable'); });
  }

  function init(){
    var path = location.pathname.toLowerCase().replace(/\/$/,'') || '/';
    if (path === '/') return;
    classify(q('#MainContent'),path);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();

  document.addEventListener('shopify:section:load',function(){
    var path = location.pathname.toLowerCase().replace(/\/$/,'') || '/';
    if (path !== '/') classify(q('#MainContent'),path);
  });
})();
